import { SessionStore } from './SessionStore';
import { DefaultFlow, ESessionStore } from '../data/Constants';

export const IsDefaultFlowInSessionStore = () => {
  return SessionStore.get(ESessionStore.Flow) === DefaultFlow;
};
